import React from "react";

import "./SubMenuItem.scss";

const SubMenuItem = ({ text }) => {
	return <li className="sub-menu-item">{text}</li>;
};

export default SubMenuItem;
